import req from '../../api/request'

export interface GameDatesParams {
  /** Root schedule (competition) the dates are scoped to. */
  scheduleId?: string | null
  teamId?: string | null
  /** Civil date, inclusive. */
  startsAfter: string
  /** Civil date, inclusive. */
  startsBefore: string
  /**
   * IANA zone the API aggregates the days in. `/games/dates` groups by
   * `DATE(tz_starts_at)` in SQL, so without this a 8:15pm Pacific game is
   * counted on the following UTC day — and at a month boundary that is the
   * month the calendar would open on.
   */
  timeZone?: string | null
}

/**
 * GET /games/dates — the days that have games, one ATOM instant each.
 *
 * A day index, not a game list: it is what the schedule views ask when they
 * need to know WHERE games are before deciding what to fetch, and it stays
 * cheap enough to ask on every filter change because the API aggregates it.
 */
export const fetchGameDates = async ({
  scheduleId,
  teamId,
  startsAfter,
  startsBefore,
  timeZone,
}: GameDatesParams): Promise<string[]> => {
  const query: Record<string, string> = {
    starts_after: startsAfter,
    starts_before: startsBefore,
  }

  if (scheduleId) {
    query.root_schedule_id = scheduleId
  }
  if (teamId) {
    query.team_id = teamId
  }
  if (timeZone) {
    query.tz = timeZone
  }

  const { data } = await req('/games/dates', { query })

  //  Historically this endpoint has answered with both plain strings and
  //  single-element arrays; callers have always had to flatten it.
  return (Array.isArray(data) ? data : []).map((entry) =>
    Array.isArray(entry) ? entry[0] : entry
  )
}
